import { render, staticRenderFns } from "./icon_config.vue?vue&type=template&id=2a30448f&"
import script from "./icon_config.vue?vue&type=script&lang=js&"
export * from "./icon_config.vue?vue&type=script&lang=js&"
import style0 from "./icon_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports